module.exports = __webpack_public_path__ + "img/logo.e98cb533.svg";